/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_6_PInputs */

const en_privacy_6_p = /** @type {(inputs: Privacy_6_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your data is kept for as long as your account exists. Delete plans, workspaces and attachments at any time from the product. To delete your whole account and all associated data, email us; we complete deletion within 30 days, except for records we must keep for tax or accounting purposes.`)
};

const id_privacy_6_p = /** @type {(inputs: Privacy_6_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datamu disimpan selama akunmu ada. Hapus plan, workspace, dan lampiran kapan saja dari dalam produk. Untuk menghapus seluruh akun beserta datanya, kirim email ke kami; penghapusan selesai dalam 30 hari, kecuali catatan yang wajib disimpan untuk keperluan pajak atau akuntansi.`)
};

/**
* | output |
* | --- |
* | "Your data is kept for as long as your account exists. Delete plans, workspaces and attachments at any time from the product. To delete your whole account and..." |
*
* @param {Privacy_6_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_6_p = /** @type {((inputs?: Privacy_6_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_6_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_6_p(inputs)
	return en_privacy_6_p(inputs)
});